(() => {
  const normalizeText = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

  const initFaqSearch = () => {
    const input = document.getElementById('FaqSearch');
    const noResults = document.getElementById('FaqNoResults');

    if (!input || input.dataset.faqSearchReady === 'true') return;
    input.dataset.faqSearchReady = 'true';

    const filterFaq = () => {
      const query = normalizeText(input.value.trim());
      const sections = Array.from(document.querySelectorAll('.section-collapsible-content'));
      let totalMatches = 0;

      sections.forEach((section) => {
        const rows = Array.from(section.querySelectorAll('collapsible-row'));
        let sectionMatches = 0;

        rows.forEach((row) => {
          const isMatch = !query || normalizeText(row.textContent).includes(query);
          row.style.display = isMatch ? '' : 'none';

          const details = row.querySelector('details');
          if (details) {
            if (query && isMatch) {
              if (!details.dataset.faqSearchState) {
                details.dataset.faqSearchState = details.open ? 'was-open' : 'opened';
              }
              details.open = true;
            } else if (!query && details.dataset.faqSearchState) {
              if (details.dataset.faqSearchState === 'opened') details.open = false;
              delete details.dataset.faqSearchState;
            }
          }

          if (isMatch) sectionMatches += 1;
        });

        section.style.display = sectionMatches ? '' : 'none';
        totalMatches += sectionMatches;
      });

      if (noResults) {
        const showNoResults = Boolean(query) && totalMatches === 0;
        noResults.hidden = !showNoResults;
        noResults.style.display = showNoResults ? 'block' : 'none';
      }
    };

    input.addEventListener('input', filterFaq);
    input.addEventListener('search', filterFaq);
    filterFaq();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqSearch, { once: true });
  } else {
    initFaqSearch();
  }

  document.addEventListener('shopify:section:load', initFaqSearch);
})();